/**
 * Create the faq accordeon open tracking object
 * @param {string} accordionItemId - Tracking Data
 */
import {BRIX_ACCORDION_ITEM_LABEL} from 'Constant';

const getAccordionHeadline = (itemId: string) => {
    let accordionHeadline = '';
    const elements = document.getElementsByClassName('brix-accordion-' + itemId)[0];
    if (elements) {
        accordionHeadline = elements.getElementsByClassName(BRIX_ACCORDION_ITEM_LABEL)[0].innerHTML.trim();
    }

    return accordionHeadline;
};
/**
 * Create the Apply Filter Tracking Object
 * @param {object} trackingData - Tracking Data
 */
export const createTrackingFaqAccordionOpen = (accordionItemId) => {
    const headline: string = getAccordionHeadline(accordionItemId);
    const trackingPayload = {
        name: headline,
        result_variant: 'faq',
        trigger_variant: 'accordion',
    };

    return trackingPayload;
};
